import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
	apiKey: 'AIzaSyC7AQz_6vc7EHVeW_JF4J4w5QHhgUkRSuM',
	authDomain: 'meisterplan-bf5a1.firebaseapp.com',
	projectId: 'meisterplan-bf5a1',
	storageBucket: 'meisterplan-bf5a1.appspot.com',
	messagingSenderId: '484496177701',
	appId: '1:484496177701:web:a82eab07a571af6e1fddcc',
};

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
